/**
 * Bio component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import * as React from "react"
import { useStaticQuery, graphql } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"

const Bio = () => {
  const data = useStaticQuery(graphql`
    query BioQuery {
      site {
        siteMetadata {
          author {
            name
            summary
          }
          social {
            twitter
          }
        }
      }
    }
  `)

  // Set these values by editing "siteMetadata" in gatsby-config.js
  const author = data.site.siteMetadata?.author
  const social = data.site.siteMetadata?.social

  return (
    <div className="bg-white rounded p-4 md:p-8 text-center border-t lg:border-none">
      <StaticImage
        className="rounded-full inline-block mb-4"
        layout="fixed"
        formats={["AUTO", "WEBP", "AVIF"]}
        src="../images/18.jpeg"
        width={100}
        height={100}
        quality={95}
        alt="Profile picture"
      />
      {author?.name && (
        <p className="text-left">
          Written by <strong>{author.name}</strong>. {author?.summary || null}
          <a
            className="underline text-blue-600 ml-2"
            href={`https://twitter.com/${social?.twitter || ``}`}
          >
            Twitter
          </a>
        </p>
      )}
    </div>
  )
}

export default Bio
